export class AuthenticatedUser {
  /**
   * Standard Angular Constructor
   *
   * @ignore
   */
  constructor(
    /* eslint-disable */
    public companyId: number,
    public username: string,
    public hashedPassword: string,
    public acceptedEula: boolean,
    public mfaRequired?: boolean,
    public mfaSms?: boolean,
    public mfaEmail?: boolean,
    public mfaToken?: string
    /* eslint-enable */
  ) {
  }
}
